<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 도급업체 -->
          <c-vendor
            name="vendorCd"
            label="도급업체"
            v-model="searchParam.vendorCd"
          ></c-vendor>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 평가구분 -->
          <c-select
            :comboItems="vendorEvaluationKindCdItem"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="vendorEvaluationKindCd"
            label="평가구분"
            v-model="searchParam.vendorEvaluationKindCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="평가일"
            :isToyear="true"
            name="evalTerms"
            v-model="searchParam.evalTerms"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="도급업체 평가 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :editable="editable"
      checkDisableColumn="rowDisabledFlag"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group>
          <c-btn label="등록" v-if="editable" :editable="editable" icon="add" @btnClicked="linkClick()" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'vendor-assess',
  data() {
    return {
      searchParam: {
        plantCd: null,
        vendorCd: null,
        vendorEvaluationKindCd: null,
        evalTerms: [],
      },
      vendorEvaluationKindCdItem: [],
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'vendorName',
            field: 'vendorName',
            label: '평가대상업체',
            style: 'width:200px',
            align: 'left',
            type: 'link',
            sortable: true,
          },
          {
            name: 'vendorEvaluationKindName',
            field: 'vendorEvaluationKindName',
            label: '평가구분',
            style: 'width:200px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'score',
            field: 'score',
            style: 'width:100px',
            label: '점수',
            align: 'center',
            sortable: true,
          },
          {
            name: 'evaluationDeptName',
            field: 'evaluationDeptName',
            label: '평가자 부서',
            style: 'width:160px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'evaluationUserName',
            field: 'evaluationUserName',
            label: '평가자',
            style: 'width:80px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '이행작업',
            style: 'width:250px',
            align: 'left',
            sortable: true,
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            style: 'width:200px',
            align: 'center',
            sortable: false,
            type: 'attach',
            taskClassCd: 'VENDOR_ASSESS',
            keyText: 'mdmVendorEvaluationId',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      typeUrl: '',
      popupOptions: {
        target: null,
        title: '',
        isFull: true,
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.mdm.cim.vendor.evaluation.result.list.url;
      this.typeUrl = selectConfig.mdm.cim.vendor.type.list.url;
      this.getTypes();
      this.getList();
    },
    getTypes() {
      this.$http.url = this.typeUrl;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.vendorEvaluationKindCdItem = _result.data;
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.popupOptions.title = "도급업체 평가 상세"; // 도급업체 평가 상세
      this.popupOptions.param = {
        mdmVendorEvaluationId: row ? row.mdmVendorEvaluationId : '',
        vendorCd: row ? row.vendorCd : '',
      };
      this.popupOptions.target = () => import(`${"./vendorAssessDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
